import { Component, inject, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { INav } from "../../types/nav";
import { selectNavSnav } from "../../store/nav/nav.selector";
import * as navActions from "../../store/nav/nav.actions";
import { RouterLink } from "@angular/router";
import { NgClass, AsyncPipe } from "@angular/common";
import { NavComponent } from "../nav/nav.component";

@Component({
  selector: "nikkan-corporate-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: true,
  imports: [RouterLink, NgClass, NavComponent, AsyncPipe],
})
export class HeaderComponent {
  private store = inject(Store);

  public snav$ = this.store.pipe(select(selectNavSnav));

  toggleSnav() {
    this.store.dispatch(navActions.toggle());
  }
}
